import { useJourneyReviewContext } from 'modules/workflows/context/JourneyReviewContext';
import { StyledBody, StyledBodyHeader } from './JourneyReview.styles';
import { JourneyIssueList } from './components/JourneyReviewList';
import { ErrorLoadingIssues, LoadingItems, NoIssuesFound } from './components/JourneyReviewState';

export const JOURNEY_ISSUE_LIST_TEST_ID = 'journey-issue-list';
export const JourneyIssues = () => {
  const { issues, isIssuesLoading, hasIssuesError, getIssues } = useJourneyReviewContext();
  if (hasIssuesError) return <ErrorLoadingIssues retry={getIssues} />;
  if (!issues.length && !isIssuesLoading) return <NoIssuesFound />;
  return (
    <StyledBody data-test={JOURNEY_ISSUE_LIST_TEST_ID}>
      <StyledBodyHeader>
        Issues that need to be resolved before you can publish this journey. (Click each item to
        view the affected tiles.)
      </StyledBodyHeader>
      {isIssuesLoading ? <LoadingItems /> : <JourneyIssueList issues={issues} />}
    </StyledBody>
  );
};
